import { memoizeOne, takeArgumentN } from "../../fpUtils";
import { isObjectPropsEquals } from "../../fpUtilsEx";
import { ICombineBaseReducerAndFieldsCfg } from "./combineReducersModel";

export function combineBaseReducerAndFieldsCoreFn(
    {
        baseReducer = null,
        subReducers = {},
        getSubReducers = null,
    }: ICombineBaseReducerAndFieldsCfg,
    state,
    action,
    ...other
) {
    const subReducersByFn = getSubReducers
        ? getSubReducers(state, action, ...other)
        : null;
    const [keys, activeSubReducers] = getAllSubReducers(
        subReducers,
        subReducersByFn
    );

    return [baseReducer(state, action, ...other), keys, activeSubReducers];
}

const getAllSubReducers = memoizeOne(
    (subReducersObj, subReducersByFn) => {
        const reducers = subReducersByFn ? { ...subReducersByFn } : {};

        for (let key of Object.keys(subReducersObj))
            if (reducers[key]) throw new Error(`Duplicate key ${key}`);
            else reducers[key] = subReducersObj[key];

        return [Object.keys(reducers), reducers];
    },
    takeArgumentN(1),
    isObjectPropsEquals
);
